import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/PosterFTschriftV2.png";
import facebookicon from "../assets/img/facebookicon.svg";
import instaIcon from "../assets/img/instaIcon.svg";

// Die ExpandableText-Komponente, die wir einfügen werden
const ExpandableText = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };



  return (
    <div>
      {/* Klickbares Wort */}
      <p onClick={toggleText} style={{ color: 'red', cursor: 'pointer', marginTop: '10px' }}className="hover-link">
        <em>Impressum</em>
      </p>

      {/* Der ausklappbare Text */}
      {isExpanded && (
        <div>
          <p>
            Verantwortlich:<br />
            <br />
            Felsenteufel Bühlertal e.V.<br />
            Postfach 12<br />
            77828 Bühlertal<br />
            <br />
            <br />
            Copyright:<br />
            Es ist nicht erlaubt Grafiken und Bilder die auf diesen Seiten ausgebracht sind ohne Genehmigung des Herausgebers zu downloaden oder zu verlinken.<br />
            <br />
            Haftungshinweis:<br />
            Das Landgericht Hamburg hat mit Urteil vom 12.05.1998 entschieden, dass man durch die Anbringung eines Links die Inhalte der gelinkten Seite ggf. mit zu verantworten hat. Dies kann - so das LG - nur dadurch verhindert werden, dass man sich ausdrücklich von diesen Inhalten distanziert.<br />
            <br />
            Wir haben auf unserer Homepage Links zu anderen Seiten im Internet gelegt. Für all diese Links gilt:<br />
            <br />
            " Wir möchten ausdrücklich betonen, dass wir keinerlei Einfluss auf die Gestaltung und die Inhalte der gelinkten Seiten haben. Deshalb distanzieren wir uns hiermit ausdrücklich von allen Inhalten aller gelinkten Seiten auf dieser gesamten Website inkl. aller Unterseiten. <br />
            <br />
            Diese Erklärung gilt für alle auf dieser Homepage ausgebrachten Links und für alle Inhalte der Seiten, zu denen Links oder Banner führen."<br />
          </p>
        </div>
      )}
    </div>
  );
}

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" style={{ width: '400px', height: 'auto' }} />
            {/* Füge die ExpandableText-Komponente unter das Logo hinzu */}
            <ExpandableText />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.facebook.com/share/1BY1oJA3Fa/" target="_blank" rel="noopener noreferrer">
                  <img src={facebookicon} alt="" />
                </a>
              <a href="https://www.instagram.com/felsenteufel?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
                  <img src={instaIcon} alt="" />
                </a>
            </div>
            <br />
            <p style={{ color: 'red', cursor: 'pointer', display: 'inline-block', marginTop: '10px' }}>
                <a href="/assets/DatenschutzFT.pdf" target="_blank" rel="noopener noreferrer" className="hover-link">
                    <em>Datenschutz</em>
                </a>
                </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}